import { useTranslation } from 'react-i18next';
import React, { useContext, useState, useEffect } from "react"
import TopSearch from "@/components/TopSearch"
import ListComponent from "@/components/listComponent"
import { getWvAccessRecord } from "@/service/allCarService"
import { MyContext } from "@/store/myContext"
import { getPcodeDict } from "@/utils/dataStorage"
import YhTooltip from "@/erp_subpackage/components/YhTooltip"
//访问列表
export default () => {
    
const { t } = useTranslation();
const { state, Option } = useContext(MyContext)
    const [goodsList, setGoodsList] = useState([]) //列表
    const [searchValue, setSearchValue] = useState({})
    const [pagination, setpagination] = useState({
        //分页配置
        total: 0,
        current: 1,
        pageSize: 10,
    })

    useEffect(() => {
        if (state.activeMenu === "allCarAccessRecord") {
            loadData(pagination.current)
        }
    }, [state.activeMenu])// eslint-disable-line react-hooks/exhaustive-deps

    //列表数据
    const loadData = (current, search = {}) => {
        let data = {
            searchItem: { ...search },
            pageNum: current,
            pageSize: 10,
            orders: [
                {
                    column: "updateTime",
                    rule: "DESC",
                },
            ],
        }
        getWvAccessRecord(data)
            .then((res) => {
                // if (res && res.retCode === 200) {
                    setpagination({
                        current: current,
                        total: res.retData.total,
                        pageSize: 10,
                    })
                    setGoodsList(res.retData.list)
                // } else {
                //     message.warning(res.retMsg)
                // }
            })
            // .catch((err) => message.error(err.retMsg))
    }
    //分页事件 置空当前行信息
    const onTableChange = async (page) => {
        await setpagination({
            ...pagination,
            current: page.current,
        })
        loadData(page.current, searchValue)
    }

    //table配置
    const columns = [
        {
            title: t(`allCarManage.allCarAccessRecord.index.客户名称`),
            align: "center",
            dataIndex: "customerName",
            render: (text) => <YhTooltip text={text} />,
        },
        {
            title: t(`allCarManage.allCarAccessRecord.index.用户名`),
            align: "center",
            dataIndex: "customerUserName",
        },
        {
            title: t(`allCarManage.allCarAccessRecord.index.用户电话`),
            align: "center",
            dataIndex: "commodityAmount",
        },
        {
            title: t(`allCarManage.allCarAccessRecord.index.所属地区`),
            align: "center",
            dataIndex: "commodityCostPrice",
        },
        {
            title: t(`allCarManage.allCarAccessRecord.index.访问日期`),
            align: "center",
            dataIndex: "commodityRetailPrice",
        },
        {
            title: t(`allCarManage.allCarAccessRecord.index.访问页面`),
            align: "center",
            dataIndex: "commodityUnderlinedPrice",
        },
        {
            title: t(`allCarManage.allCarAccessRecord.index.访问车型`),
            align: "center",
            dataIndex: "commodityPointPrice",
        },
        {
            title: t(`allCarManage.allCarAccessRecord.index.停留时常`),
            align: "center",
            dataIndex: "accessStayTime",
        },
    ]
    //搜索JSON
    const searchList = {
        normalList: [
            {
                type: "select",
                placeholder: t(`allCarManage.allCarAccessRecord.index.请选择区域`),
                valueName: "commodityType",
                optionList: () =>
                    getPcodeDict("025").children.map((item) => (
                        <Option key={item.id} value={item.dictCode}>
                            {item.title}
                        </Option>
                    )),
            },
            {
                type: "input",
                placeholder: t(`allCarManage.allCarAccessRecord.index.请输入客户名称`),
                valueName: "commodityName",
            },
            {
                type: "input",
                placeholder: t(`allCarManage.allCarAccessRecord.index.请输入联系人`),
                valueName: "commodityName1",
            },
            {
                type: "RangePicker",
                valueName: ["startTime", "endTime"],
                span: 16,
                xxl: 8,
            },
        ],
    }

    return (
        <>
            {state.activeMenu === "allCarAccessRecord" && (
                <>
                    <TopSearch
                        title= {t(`allCarManage.allCarAccessRecord.index.访问记录`)}
                        searchListData={searchList}
                        searchValue={searchValue}
                        setSearchValue={(obj) => setSearchValue(obj)}
                        handleSearch={loadData}
                    />
                    <ListComponent title= {t(`allCarManage.allCarAccessRecord.index.访问记录`)} columns={columns} dataSource={goodsList} pagination={pagination} onTableChange={onTableChange} />
                </>
            )}
        </>
    )
}
